const workbench = {
  'pages.settings.workbench.launch.workFlowNo': '审核单号',
  'pages.settings.workbench.launch.name': '审核名称',
  'pages.settings.workbench.launch.currentAuditorName': '当前审核人',
  'pages.settings.workbench.launch.auditNodeName': '审核节点',
  'pages.settings.workbench.launch.creatorName': '发起人',
  'pages.settings.workbench.launch.createdTime': '发起时间',
}
export default workbench
